import { render, staticRenderFns } from "./TableWidgetDeleted.vue?vue&type=template&id=3daa428d"
import script from "./TableWidgetDeleted.vue?vue&type=script&lang=js"
export * from "./TableWidgetDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports